<div class="dashboard">
  <!-- Quick Upload Receipt-->
  <div
    *ngIf="!hideFirstUseBlock"
    class="first-use-container"
  >
    <ems-base-icon
      iconName="close"
      class="icon close"
      (click)="closeFirstUseBlock()"
    ></ems-base-icon>
    <p class="title">New to Spense?</p>
    <div class="resources">
      <div
        class="resource"
        (click)="openLink('https://drive.google.com/file/d/1RShMVhVkbZAYmumTQa-eFH8Pbo0XA-oB/view')"
      >
        <ems-base-icon
          iconName="play_circle"
          class="icon"
        ></ems-base-icon>
        <span class="resource-type">Watch:</span>
        <span class="resource-text">How to submit an expense</span>
      </div>
      <div
        class="resource"
        (click)="openLink('https://drive.google.com/file/d/18R-8K29NRIQ-raJgRjFL_5Qy2HulPNfX/view?usp=sharing')"
      >
        <ems-base-icon
          iconName="library_books"
          class="icon"
        ></ems-base-icon>
        <span class="resource-type">Read:</span>
        <span class="resource-text">Spense user guide</span>
      </div>
    </div>
    <p class="footer">
      You can access these and more materials at any time using the help icon
      <ems-base-icon
        iconName="help_outline"
        class="icon help"
      ></ems-base-icon> at the top of the page
    </p>
  </div>
  <!-- <section class="dashboard__receipt-upload">
    <div
      #dropzoneContainer
    >
      <div
        #dropzone
        class="upload-container"
        [dropzone]="config"
        (click)="onClickFileSelect($event)"
        (addedFile)="waitForConfirmation($event)"
        (error)="onUploadError($event)"
        (success)="onUploadSuccess($event)"
      >
        <div
          #quickUploadCreditCardContainer
          [ngClass]="(creditCardUser$ | async) ? 'dz-message quick-upload quick-upload__cc-holder' : 'dz-message quick-upload'"
        >
        <ems-base-icon
          iconName="upload-circle"
          class="quick-upload__icon"
        ></ems-base-icon>
        <span
          #quickUploadCreditCardHolderMessage
          *ngIf="(creditCardUser$ | async)"
          class="quick-upload__cc-holder-message"
        >
          Choose this option when you have paid using your own personal credit card or cash
        </span>
        <span
          #quickUploadCreditCardLabel
          class="quick-upload__label">Upload Receipt
        </span>
        <span class="quick-upload__caption">(or drag and drop here)</span>
      </div>
    </div>


    </div>

  </section> -->

  <!-- Actions -->
  <section
    #oopDashboardContainer
    [ngClass] = "(creditCardUser$ | async) ? 'dashboard__actions-2' : 'dashboard__actions-2'"
  >
      <button
        class="dashboard-action"
        *ngIf="(creditCardUser$ | async)"
        (click)="onOpenModal('expense-new-modal-company-cc')"
      >
        <div class="dashboard-action__icon">
          <ems-base-icon iconName="credit-card"></ems-base-icon>
        </div>
        <p class="dashboard-action__label">New Company Credit Card Expense</p>
      </button>
      <button
        #oopDashboardButton
        [ngClass]="(creditCardUser$ | async) ? 'dashboard-action new-expense dashboard-action__cc-holder' : 'dashboard-action new-expense'"
        (click)="onOpenModal('expense-new-modal')"
      >
        <div
          #oopDashboardIcon
          [ngClass]="(creditCardUser$ | async) ? 'dashboard-action__icon dashboard-action__cc-holder__icon' : 'dashboard-action__icon'"
        >
          <ems-base-icon iconName="expense-circle"></ems-base-icon>
        </div>
        <p
          #oopDashboardLabel
          [ngClass]="(creditCardUser$ | async) ? 'dashboard-action__label dashboard-action__out-of-pocket-label' : 'dashboard-action__label'"
        >New Out of Pocket Expense</p>
        <p
          #oopCCHolderMessage
          *ngIf="(creditCardUser$ | async)"
          class="dashboard-action__cc-holder-message"
        >
          Choose this option when you have paid using your own personal credit card or cash</p>
        <button
          #oopDashboardCCHolderButton
          *ngIf="(creditCardUser$ | async)"
          class="dashboard-action__cc-holder-button"
        >Tap to Continue</button>
      </button>
      <button
      class="dashboard-action new-mileage"
      (click)="onOpenModal('mileage-expense-modal-new')"
    >
      <div class="dashboard-action__icon">
        <ems-base-icon iconName="car"></ems-base-icon>
      </div>
      <p class="dashboard-action__label">New Mileage Expense</p>
    </button>


  </section>

  <!-- Widgets -->
  <section class="dashboard__widgets" [class.no-approvals]="!isApprover">
    <!-- Widget: Expenses -->
    <div
      class="widget widget--expenses"
      *ngIf="!summaryLoading; else loadingExpense"
    >
      <h2 class="widget__heading">Expenses Summary</h2>
      <div class="widget__content">
        <article class="widget__section">
          <h3 class="widget__subheading">Requiring Submission</h3>
          <p class="widget__data-point">
            {{
              submissionCounts.draft.value + submissionCounts.rejected.value
                | convertToDollars
                | currency
            }}
          </p>
          <a
            routerLink="/expenses/unsubmitted"
            [ngPlural]="requiredSubmissionCount"
          >
            <ng-template ngPluralCase="1">1 Expense</ng-template>
            <ng-template ngPluralCase="other">
              {{ requiredSubmissionCount }} Expenses
            </ng-template>
          </a
          >
        </article>
        <article class="widget__section">
          <h3 class="widget__subheading">Pending</h3>
          <p class="widget__data-point">
            {{ submissionCounts.pending.value | convertToDollars | currency }}
          </p>
          <a routerLink="/expenses/submitted" [ngPlural]="pendingCount">
            <ng-template ngPluralCase="1">1 Expense</ng-template>
            <ng-template ngPluralCase="other">
              {{ pendingCount }} Expenses
            </ng-template>
          </a>
        </article>

        <article class="widget__section">
          <h3 class="widget__subheading">Approved</h3>
          <p class="widget__data-point">
            {{ submissionCounts.approved.value | convertToDollars | currency }}
          </p>
          <a
            routerLink="/expenses/submitted"
            [ngPlural]="submissionApprovedCount"
          >
            <ng-template ngPluralCase="1">1 Expense</ng-template>
            <ng-template ngPluralCase="other">
              {{ submissionApprovedCount }} Expenses
            </ng-template>
          </a>
        </article>
      </div>
    </div>

    <ng-template #loadingExpense>
      <div class="widget widget--expenses">
        <h2 class="widget__heading">Expenses Summary</h2>
        <div class="widget__content loading">
          <div class="spinner-container">
            <ems-base-icon class="spinner" iconName="loading"></ems-base-icon>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Widget: Approvals Summary -->
    <div
      class="widget widget--approvals"
      *ngIf="isApprover && !summaryLoading; else loadingApproval"
    >
      <h2 class="widget__heading">Approvals Summary</h2>
      <div class="widget__content">
        <article class="widget__section">
          <h3 class="widget__subheading">Awaiting Review</h3>
          <p class="widget__data-point">
            {{ approvalCounts.unapproved.value | convertToDollars | currency }}
          </p>
          <a routerLink="/approvals/awaiting" [ngPlural]="unapprovedCount">
            <ng-template ngPluralCase="1">1 Expense</ng-template>
            <ng-template ngPluralCase="other">
              {{ unapprovedCount }} Expenses
            </ng-template>
          </a>
        </article>
        <article class="widget__section">
          <h3 class="widget__subheading">Overdue</h3>
          <p class="widget__data-point">
            {{ approvalCounts.overdue.value | convertToDollars | currency }}
          </p>
          <p
            class="widget__caption approvals-overdue"
            [ngPlural]="overdueCount"
          >
            <ng-template ngPluralCase="1">1 Expense</ng-template>
            <ng-template ngPluralCase="other">
              {{ overdueCount }} Expenses
            </ng-template>
          </p>
        </article>
        <article class="widget__section">
          <h3 class="widget__subheading">Approved</h3>
          <p class="widget__data-point">
            {{ approvalCounts.approved.value | convertToDollars | currency }}
          </p>
          <a routerLink="/approvals/reviewed" [ngPlural]="approvedCount">
            <ng-template ngPluralCase="1">1 Expense</ng-template>
            <ng-template ngPluralCase="other">
              {{ approvedCount }} Expenses
            </ng-template>
          </a>
        </article>
      </div>
    </div>

    <!-- <ng-template #noApprover>
      <div class="widget widget--no-approvals"></div>
    </ng-template> -->

    <ng-template #loadingApproval>
      <div
        class="widget widget--expenses loading-approval"
        *ngIf="isApprover && summaryLoading"
      >
        <h2 class="widget__heading">Approvals Summary</h2>
        <div class="widget__content loading">
          <div class="spinner-container">
            <ems-base-icon class="spinner" iconName="loading"></ems-base-icon>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Widget: Recent Submissions -->
    <div class="widget widget--recent-submissions">
      <h2 class="widget__heading">Recent Submissions</h2>
      <div class="widget__content submissions">
        <div
          *ngIf="recentSubmissions.length; else recentBlankSlate"
          class="recent-submissions-list"
        >
          <details
            *ngFor="let submission of recentSubmissions"
            class="expense-item"
          >
            <summary>
              <div class="expense-item__header">
                <div
                  *ngIf="submission.thumbnail; else paymentIcon"
                  class="expense-item__thumbnail"
                >
                  <img [src]="submission.thumbnail" />
                </div>
                <ng-template #paymentIcon>
                  <div class="expense-item__payment-icon">
                    <ems-base-icon
                      iconName="credit-card"
                      *ngIf="submission.cardVerified"
                    ></ems-base-icon>
                    <ems-base-icon
                      iconName="receipt-unverified"
                      *ngIf="!submission.cardVerified"
                    ></ems-base-icon>
                  </div>
                </ng-template>
                <div class="expense-item__title">
                  <p class="expense-item__vendor">{{ submission.vendor }}</p>
                  <p class="expense-item__amount">
                    {{ submission.amount | convertToDollars | currency }}
                  </p>
                </div>
                <p class="expense-item__date">
                  {{ submission.createdAt | date: 'shortDate' }}
                </p>
                <div class="expense-item__status">
                  <ems-expense-status
                    [status]="submission.status"
                  ></ems-expense-status>
                </div>
              </div>
            </summary>
            <div class="expense-item__body">
              <a
                class="expense-item__id"
                (click)="openExpenseModal(submission.id)"
                >ID #{{ submission.id }}</a
              >
              <div class="expense-item__transaction-date">
                Transaction Date:
                {{ submission.transactionDate | expenseDate }}
              </div>

              <div class="expense-item__payment-type">
                <p class="expense-item__payment-type">
                  {{ getPaymentType(submission.paymentType) }}
                </p>
              </div>
              <div class="expense-item__meta">
                <span *ngIf="submission.type" class="expense-item__type">{{
                  submission.type.name
                }}</span>
                <span class="expense-item__billable-status"
                  ><span *ngIf="!submission.isBillable">Non–</span
                  >Billable</span
                >
              </div>
            </div>
            <div class="expense-item__footer">
              <a (click)="onOpenModal('expense-modal', submission.id)"
                >View Expense</a
              >
            </div>
          </details>
        </div>
        <ng-template #recentBlankSlate>
          <div class="submission-blank" *ngIf="!expensesLoading">
            <button
              class="submission-blank__icon"
              (click)="onOpenModal('expense-new-modal')"
            >
              <ems-base-icon iconName="expense-circle"></ems-base-icon>
            </button>
            <p class="submission-blank__title">Create a new expense</p>
            <p class="submission-blank__caption">
              (Recent Submissions Will Appear Here)
            </p>
          </div>
          <div class="submission-blank" *ngIf="expensesLoading">
            <ems-base-icon
              class="spinner spinner__large"
              iconName="loading"
            ></ems-base-icon>
          </div>
        </ng-template>
      </div>
    </div>
  </section>
</div>
